var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineForward5Seconds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "90B7233C-9412-4C7F-BA74-9B084B139C8F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video,-Audio,-Image",
    transform: "translate(-108.000000, -508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forward-5-seconds",
    transform: "translate(108.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3997808,4.93996024 L11.4197392,2.4699285 C11.1597392,2.14992851 11.2097343,1.66994065 11.5397343,1.41994065 C11.8697343,1.16994065 12.3297831,1.20993575 12.5897831,1.53993577 L14.5697637,4.00996757 C14.8297637,4.32996756 14.7797686,4.80995536 14.4497685,5.05995536 C14.3097685,5.15995536 14.1397368,5.2199285 13.9797368,5.2199285 C13.7597368,5.2199285 13.5397808,5.11996025 13.3997808,4.93996024 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.359375,13.1097412 C2.359375,7.78974104 6.67938948,3.46972656 11.9993896,3.46972656 C12.6893896,3.46972656 13.3894141,3.54973632 14.1494141,3.72973633 C14.5494141,3.81973633 14.8094116,4.22976074 14.7094116,4.62976074 C14.6194116,5.02976075 14.2193872,5.2897583 13.8093872,5.1897583 C13.1693872,5.03975829 12.5693896,4.96972656 11.9993896,4.96972656 C7.50938988,4.96972656 3.859375,8.61974144 3.859375,13.1097412 C3.859375,17.599741 7.50938988,21.2497559 11.9993896,21.2497559 C16.4893894,21.2497559 20.1394043,17.599741 20.1394043,13.1097412 C20.1394043,11.3697412 19.5693799,9.68975592 18.4893799,8.24975586 C18.2393799,7.91975585 18.3094043,7.44976807 18.6394043,7.19976807 C18.9694043,6.94976807 19.4393921,7.01973143 19.6893921,7.34973145 C20.9693921,9.04973149 21.6394043,11.0397413 21.6394043,13.1097412 C21.6394043,18.4297414 17.3093896,22.7497559 11.9993896,22.7497559 C6.68938971,22.7497559 2.359375,18.4297414 2.359375,13.1097412 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0906458,16.9202881 C9.68064579,16.9202881 9.34064581,16.5802881 9.34064581,16.1702881 C9.34064581,15.7602881 9.68064579,15.4202881 10.0906458,15.4202881 L12.3806238,15.4202881 C12.8106238,15.4202881 13.1605921,15.0703125 13.1605921,14.6403198 C13.1605921,14.2103198 12.8106238,13.8602905 12.3806238,13.8602905 L10.0906458,13.8602905 C9.8506458,13.8602905 9.62059943,13.740293 9.48059943,13.550293 C9.34059943,13.360293 9.30062384,13.1003003 9.38062384,12.8703003 L10.1406336,10.5803223 C10.2406336,10.2703223 10.5305945,10.0703125 10.8505945,10.0703125 L13.9105921,10.0703125 C14.3205921,10.0703125 14.6605921,10.4103125 14.6605921,10.8203125 C14.6605921,11.2303125 14.3205921,11.5703125 13.9105921,11.5703125 L11.3906336,11.5703125 L11.1306238,12.3602905 L12.3806238,12.3602905 C13.6406238,12.3602905 14.6605921,13.3803198 14.6605921,14.6403198 C14.6605921,15.9003198 13.6406238,16.9202881 12.3806238,16.9202881 L10.0906458,16.9202881 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineForward5Seconds);
export default __webpack_public_path__ + "static/media/vuesax-outline-forward-5-seconds.aa80a0f6b114c563314765d3ce7bb30a.svg";
export { ForwardRef as ReactComponent };